import { render, staticRenderFns } from "./DislikedProfiles.vue?vue&type=template&id=1cfb5695&"
import script from "./DislikedProfiles.vue?vue&type=script&lang=js&"
export * from "./DislikedProfiles.vue?vue&type=script&lang=js&"
import style0 from "./DislikedProfiles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports